<template>
  <div v-if="loading" class="lead-flow-overview lead-flow-overview--loading" aria-hidden="true">
    <section v-for="index in 3" :key="index" class="lead-flow-overview__skeleton">
      <span></span>
      <i></i>
      <i></i>
      <i></i>
    </section>
  </div>
  <div v-else class="lead-flow-overview">
    <LeadContactDetails :contact="detail.contact_details || {}" />
    <LeadTravelDetails
      :country="detail.country"
      :activities="detail.activities || []"
      :party="detail.party || {}"
      :travel="detail.travel || {}"
      :travel-dates="detail.travel_dates || ''"
      :child-ages="(detail.request_info && detail.request_info.child_ages) || ''"
      :currency="detail.currency"
    />
    <LeadTripDetails
      :request="detail.request_text || ''"
      :source="detail.source"
      :url="detail.url || ''"
    />
    <LeadManagementGuidance
      :lead-id="detail.id"
      :initial="detail.management_guidance"
      @changed="$emit('guidance-changed', $event)"
    />
    <LeadProgramDetails
      v-if="detail.program || detail.tour_operator"
      :program="detail.program"
      :tour-operator="detail.tour_operator"
    />
  </div>
</template>

<script>
import LeadContactDetails from '@/views/crm/task-tracker/LeadContactDetails.vue'
import LeadProgramDetails from '@/views/crm/task-tracker/LeadProgramDetails.vue'
import LeadTravelDetails from '@/views/crm/task-tracker/LeadTravelDetails.vue'
import LeadTripDetails from '@/views/crm/task-tracker/LeadTripDetails.vue'
import LeadManagementGuidance from '@/views/crm/task-tracker/LeadManagementGuidance.vue'

export default {
  name: 'LeadOverview',
  components: {
    LeadContactDetails,
    LeadProgramDetails,
    LeadTravelDetails,
    LeadTripDetails,
    LeadManagementGuidance
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.lead-flow-overview {
  display: grid;
  min-width: 0;
  align-content: start;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.lead-flow-overview__wide {
  grid-column: 1 / -1;
}

.lead-flow-overview-section {
  min-width: 0;
  padding: 15px 16px;
  border: 1px solid #dfe4dc;
  border-radius: 7px;
  background: #fff;
}

.lead-flow-overview-section h3 {
  margin: 0 0 13px;
  padding-bottom: 9px;
  border-bottom: 1px solid #e8ebe5;
  color: #1f3134;
  font-size: 15px;
  line-height: 20px;
}

.lead-flow-overview-section dl {
  display: grid;
  gap: 9px;
  margin: 0;
}

.lead-flow-overview-section dl > div {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(105px, .85fr) minmax(0, 1.15fr);
  align-items: start;
  gap: 10px;
}

.lead-flow-overview-section dt {
  color: #7f8c8b;
  font-size: 16px;
  line-height: 20px;
}

.lead-flow-overview-section dd {
  min-width: 0;
  overflow-wrap: anywhere;
  margin: 0;
  color: #344749;
  font-size: 16px !important;
  font-weight: 600;
  line-height: 20px;
  text-align: right;
}

.lead-flow-modal .lead-flow-overview .lead-flow-travel-details__country strong,
.lead-flow-modal .lead-flow-overview .lead-flow-trip-details__request p,
.lead-flow-modal .lead-flow-overview .lead-flow-trip-details__request > span {
  font-size: 16px !important;
}

.lead-flow-overview-section dd a {
  color: #3976ae;
  text-decoration: none;
}

.lead-flow-overview-section dd a:hover {
  text-decoration: underline;
}

.lead-flow-overview__skeleton {
  display: grid;
  gap: 10px;
  padding: 15px 16px;
  border: 1px solid #dfe4dc;
  border-radius: 7px;
  background: #fff;
}

.lead-flow-overview__skeleton:nth-child(n + 3) {
  grid-column: 1 / -1;
}

.lead-flow-overview__skeleton span,
.lead-flow-overview__skeleton i {
  display: block;
  height: 13px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e7ebe6 25%, #f6f7f4 50%, #e7ebe6 75%);
  background-size: 200% 100%;
  animation: lead-flow-overview-pulse 1.4s ease-in-out infinite;
}

.lead-flow-overview__skeleton span {
  width: 90px;
  height: 18px;
  margin-bottom: 5px;
}

.lead-flow-overview__skeleton i {
  width: 75%;
}

.lead-flow-overview__skeleton i:nth-child(odd) {
  width: 90%;
}

@keyframes lead-flow-overview-pulse {
  from {
    background-position: 100% 0;
  }

  to {
    background-position: -100% 0;
  }
}

@media (max-width: 760px) {
  .lead-flow-overview {
    grid-template-columns: 1fr;
  }

  .lead-flow-overview__wide,
  .lead-flow-overview__skeleton:nth-child(n + 3) {
    grid-column: auto;
  }
}
</style>
